import {createContext} from 'react'
import {ModalRoboyuLevelUpHandler} from 'types'

export const ModalRoboyuLevelUpContext = createContext<ModalRoboyuLevelUpHandler | undefined>(
  undefined,
)
